<div class="footer">
  <div class="d-flex mobile-res">
    <div class="footer-logo">
      <a routerLink="/">
        <img src="assets/images/taly-footer-logo.svg" alt="Footer logo" />
      </a>
    </div>
    <ul class="socila-media">
      @for (account of socialMedia; track $index) {
        <li>
          <a [href]="account?.url" target="_blank" rel="noopener noreferrer">
            <img [src]="account?.icon" alt="{{ account?.name }}" />
          </a>
        </li>
      }
    </ul>
    <div class="language-icon">
      <div
        class="language"
        (click)="toggleText()"
        (keyup.enter)="toggleText()"
        tabindex="0"
        role="button"
      >
        <img
          [src]="
            textDirection === 'rtl'
              ? 'assets/images/en-lang-logo.svg'
              : 'assets/images/arebic-lang-icon.svg'
          "
          alt="lang-logo"
        />
        <label for="lang" translate> LANGUAGE</label>
      </div>
    </div>
  </div>
  <div class="d-flex download-app-link">
    <div class="app-store">
      <h4 translate>FOOTER.DOWNLOAD</h4>
      <a
        href="javascript:void(0)"
        target="_blank"
        rel="noopener noreferrer"
        (click)="onClickLink($event, appLink)"
        (keyup.enter)="onKeyupLink()"
        tabindex="0"
        role="button"
      >
        <img [src]="appIcon" alt="QR Code" />
      </a>
    </div>
  </div>
  <div class="d-flex list-item">
    <ul>
      <li><a translate>FOOTER.SHOPERS</a></li>
      <li><a routerLink="/faq-shopper" translate>FOOTER.FAQ</a></li>

      <!-- [TODO] : as requested on 24 May 2025 from sulaiman we are hiding temparary later will enable, so dont delete this code -->
      <!-- <li><a routerLink="/shops" translate>FOOTER.SHOPS</a></li>  -->
      <li><a routerLink="/terms-and-conditions" translate>FOOTER.TERMS</a></li>
      <li><a routerLink="/customer-complaints" translate>FOOTER.CUSTOMER_COMPLAINTS</a></li>
    </ul>
    <ul>
      <li><a translate>FOOTER.PARTNERS</a></li>
      <li><a routerLink="/partner/sign-up" translate>FOOTER.SIGNUP</a></li>
      <li><a routerLink="/faq-partner" translate>FOOTER.FAQ</a></li>
      <li>
        <a [href]="envService.MerchantURL" target="_blank" rel="noopener noreferrer" translate
          >FOOTER.PARTNER_PORTAL
        </a>
      </li>
      <li>
        <a [href]="envService.DocsURL" target="_blank" rel="noopener noreferrer" translate
          >FOOTER.DEVELOPER
        </a>
      </li>
    </ul>
    <ul>
      <li><a translate>FOOTER.ABOUT</a></li>
      <!-- <li><a routerLink="/sharia-board"  translate>FOOTER.SHARIA</a></li> -->
      <!-- <li><a href="javascript:void(0)" translate>FOOTER.CARRIES</a></li> -->
      <li><a routerLink="/press" translate>FOOTER.PRESS</a></li>
    </ul>
    <div class="qr-code" id="targetAppDownload">
      <div class="qr-link">
        <a
          href="javascript:void(0)"
          (click)="envService.onLinkClick($event, appLink)"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="assets/images/new-qr.svg" class="cursor" alt="qr-code" />
        </a>
        <p translate>FOOTER.GET_FREE_APP</p>
      </div>
      <!-- <div>
                <h4 translate>FOOTER.DOWNLOAD</h4>
                <span translate>FOOTER.SCAN</span>
            </div> -->
    </div>
  </div>
  <hr />
  <div class="d-flex bottom-header">
    <div
      class="language-button"
      role="button"
      tabindex="0"
      (click)="toggleText()"
      (keyup.enter)="toggleText()"
    >
      <div class="language">
        <!-- <img src="assets/images/footer-white-logo.svg" alt=""> -->
        <img
          [src]="
            textDirection === 'rtl'
              ? 'assets/images/en-lang-logo.svg'
              : 'assets/images/arebic-lang-icon.svg'
          "
          alt="lang-logo"
        />

        <label for="lang" translate> LANGUAGE</label>
      </div>
    </div>

    <ul>
      @for (type of paymentPartners; track $index) {
        <li>
          <img [src]="type.icon" [alt]="type.name" />
        </li>
      }
    </ul>
    <div class="copy-right">
      <ul>
        <!-- <li><a routerLink="/terms-and-conditions" translate>FOOTER.TERMS</a></li> -->
        <li><a routerLink="/privacy-policy" translate>FOOTER.PRIVACY</a></li>
        <li><a translate [translateParams]="{ year: currentYear }"> FOOTER.COPY_RIGHT</a></li>
        <!-- [translateParams]="{ currentYear : currentYear}" -->
      </ul>
    </div>
  </div>
</div>
